import {
   getSingleProductNavItemsEng,
   getSingleProductNavItemsGer,
   getSingleProductNavItemsPol,
   getSingleProductNavItemsUkr
} from 'api';
import arrow from 'assets/arrow.svg';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useParams } from 'react-router-dom';
import { APP_LANGS } from 'state/app';
import styled, { css } from 'styled-components';
import { colors } from 'styles/colors';

const getMenu = (lang) => {
   switch (lang) {
      default:
      case APP_LANGS.POL:
         return getSingleProductNavItemsPol;
      case APP_LANGS.ENG:
         return getSingleProductNavItemsEng;
      case APP_LANGS.UKR:
         return getSingleProductNavItemsUkr;
      case APP_LANGS.GER:
         return getSingleProductNavItemsGer;
   }
};

const ProductNavigation = () => {
   const [links, setLinks] = useState([]);
   const [active, setActive] = useState([]);
   const params = useParams();
   const lang = useSelector((s) => s.app.lang);
   const getNavItems = getMenu(lang);

   useEffect(() => {
      setActive([]);
      getNavItems().then(({ data }) => {
         const navLinks = data?.items?.map((itemLevel1) => {
            if (itemLevel1?.children?.length) {
               return {
                  tag: 'button',
                  title: itemLevel1?.title,
                  id: itemLevel1?.id,
                  navId: itemLevel1?.id,
                  slug: itemLevel1?.object_slug,
                  children: itemLevel1?.children?.map((itemLevel2) => {
                     if (itemLevel2?.children?.length) {
                        return {
                           tag: 'button',
                           title: itemLevel2?.title,
                           id: itemLevel2?.id,
                           slug: itemLevel2?.object_slug,
                           navId: itemLevel2?.id,
                           children: itemLevel2?.children?.map((itemLevel3) => {
                              return {
                                 tag: 'link',
                                 title: itemLevel3?.title,
                                 id: itemLevel3?.object_id,
                                 slug: itemLevel3?.object_slug,
                                 navId: itemLevel3?.id
                              };
                           })
                        };
                     }

                     return {
                        tag: 'link',
                        title: itemLevel2?.title,
                        id: itemLevel2?.object_id,
                        slug: itemLevel2?.object_slug,
                        navId: itemLevel2?.id
                     };
                  })
               };
            } else {
               return {
                  tag: 'link',
                  title: itemLevel1?.title,
                  id: itemLevel1?.object_id,
                  slug: itemLevel1?.object_slug,
                  navId: itemLevel1?.id
               };
            }
         });

         setLinks(navLinks);
      });
   }, [params]);

   return (
      <nav>
         {!!links.length && (
            <NavListLevel1>
               {links?.map((level1) => (
                  <NavItemLevel1
                     key={level1?.id}
                     active={
                        level1.children &&
                        level1.children.some(
                           (el) =>
                              `${el.id}` === params?.productId ||
                              el?.children?.some((item) => `${item.id}` === params?.productId) ||
                              active?.includes(level1?.id)
                        )
                     }
                  >
                     <button
                        type="button"
                        onClick={() => {
                           if (active.includes(level1?.id)) {
                              setActive([]);
                           } else {
                              setActive([level1?.id]);
                           }
                        }}
                     >
                        <Arrow
                           active={
                              level1.children &&
                              level1.children.some(
                                 (el) =>
                                    `${el.id}` === params?.productId ||
                                    el?.children?.some(
                                       (item) => `${item.id}` === params?.productId
                                    ) ||
                                    active?.includes(level1?.id)
                              )
                           }
                        >
                           <img src={arrow} alt="" />
                        </Arrow>
                        <ButtonName>{level1?.title}</ButtonName>
                     </button>
                     {level1.children &&
                        level1.children.some(
                           (el) =>
                              `${el.id}` === params?.productId ||
                              el?.children?.some((item) => `${item.id}` === params?.productId) ||
                              active?.includes(level1?.id)
                        ) && (
                           <NavListLevel2>
                              {level1.children.map((level2) => (
                                 <NavItemLevel2 key={level2?.id}>
                                    {level2.tag === 'button' ? (
                                       <>
                                          <button
                                             onClick={() => {
                                                if (active.includes(level2?.id)) {
                                                   setActive((prev) => [prev[0]]);
                                                } else {
                                                   setActive((prev) => [...prev, level2?.id]);
                                                }
                                             }}
                                          >
                                             <Arrow
                                                active={level2.children?.some(
                                                   (el) =>
                                                      `${el.id}` === params?.productId ||
                                                      active?.includes(level2?.id)
                                                )}
                                             >
                                                <img src={arrow} alt="" />
                                             </Arrow>
                                             <ButtonName>{level2?.title}</ButtonName>
                                          </button>
                                          {level2.children?.some(
                                             (el) =>
                                                `${el.id}` === params?.productId ||
                                                active?.includes(level2?.id)
                                          ) && (
                                             <NavListLevel3>
                                                {level2.children?.map((level3) => (
                                                   <NavItemLevel3 key={level3?.id}>
                                                      <StyledNavLink
                                                         to={`/katalog/produkty/${level3?.id}`}
                                                      >
                                                         {level3?.title}
                                                      </StyledNavLink>
                                                   </NavItemLevel3>
                                                ))}
                                             </NavListLevel3>
                                          )}
                                       </>
                                    ) : (
                                       <StyledNavLink to={`/katalog/produkty/${level2?.id}`}>
                                          {level2?.title}
                                       </StyledNavLink>
                                    )}
                                 </NavItemLevel2>
                              ))}
                           </NavListLevel2>
                        )}
                  </NavItemLevel1>
               ))}
            </NavListLevel1>
         )}
      </nav>
   );
};

const StyledNavLink = styled(NavLink)`
   display: block;
   cursor: pointer;
   color: ${colors.neutral10};
   background: none;
   width: 100%;
   text-align: left;
   border: none;
   padding: 0;

   &:hover {
      text-decoration: none;
      color: ${colors.neutral50};
   }

   &.active {
      color: ${colors.primary};
   }
`;

const List = styled.ul`
   display: block;
   list-style-type: none;
   padding: 0;
   margin: 0 20px 0 0;
   width: 100%;
`;

const NavListLevel1 = styled(List)``;

const NavListLevel2 = styled(List)`
   background: #3a3f40;
   border-radius: 20px;
   padding: 20px;
   margin-top: 10px;

   button {
      margin-top: 10px;
   }
`;

const NavListLevel3 = styled(List)`
   background: ${colors.neutral60};
   border-radius: 20px;
   padding: 20px;
   margin-top: 10px;
`;

const NavItem = styled.li`
   display: block;
   width: 100%;
   padding: 0;
   margin: 0;
   font-size: 14px;

   button,
   a {
      display: block;
      cursor: pointer;
      color: ${colors.neutral10};
      background: none;
      width: 100%;
      text-align: left;
      border: none;
      padding: 0;
   }
`;

const Arrow = styled.span`
   display: inline-block;

   img {
      display: block;
      margin: 0 0 3px;
   }

   ${({ active }) =>
      active &&
      css`
         transform: rotate(180deg);

         img {
            margin: 3px 0 0;
         }
      `}
`;

const ButtonName = styled.span`
   display: inline-block;
   padding-left: 10px;
`;

const NavItemLevel1 = styled(NavItem)`
   padding: 7px 0;

   ${({ active }) =>
      !active &&
      css`
         &:not(:last-of-type) {
            border-bottom: 1px solid ${colors.neutral60};
         }
      `}
`;

const NavItemLevel2 = styled(NavItem)`
   padding: 4px 0;
`;

const NavItemLevel3 = styled(NavItem)`
   padding: 4px 0;
`;

export default ProductNavigation;
